export function devWarn(msg, err) {
    if (process.env.NODE_ENV !== "production") console.warn(msg, err);
}
